<div class="container-fluid w-100 h-100">
  <div class="row h-100">
    <div class="d-flex flex-column flex-fill align-items-center justify-content-center">
      <h2>404</h2>

      <h2>Page not found</h2>
    </div>
  </div>
</div>
